"use client";
import { useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";

const SlideToggle = ({ isOpen, duration = 300, children, customHeight }) => {
  const [height, setHeight] = useState("0px");
  const nodeRef = useRef(null);

  const onEntering = () => {
    if (nodeRef.current) {
      setHeight(`${nodeRef.current.scrollHeight + customHeight}px`);
    }
  };

  const onEntered = () => {
    setHeight("auto");
  };

  const onExit = () => {
    if (nodeRef.current) {
      setHeight(`${nodeRef.current.scrollHeight}px`);
      requestAnimationFrame(() => {
        setHeight("0px");
      });
    }
  };

  return (
    <CSSTransition
      in={isOpen}
      timeout={duration}
      nodeRef={nodeRef}
      onEntering={onEntering}
      onEntered={onEntered}
      onExit={onExit}
      unmountOnExit
    >
      <div
        ref={nodeRef}
        style={{ maxHeight: height, transitionDuration: `${duration}ms` }}
        className={`overflow-hidden transition-[max-height] ease-in-out`}
      >
        {children}
      </div>
    </CSSTransition>
  );
};

export default SlideToggle;
